
$('.gallery').each(function() {
    var pckry = new Packery( this, {
        columnWidth: '.grid-sizer',        
        itemSelector: '.grid-item',
        percentPosition: true,
        gutter:'.grid-gutter-sizer'
    });
});